import type { ReactNode } from 'react';

import {
  BREAKPOINTS,
  useMediaQuery,
} from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import BpkDrawer from '@skyscanner-internal/backpack-web/bpk-component-drawer';

import { onePixelRem } from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import STYLES from './SponsoredDrawerShell.module.scss';

type SponsoredDrawerShellProps = {
  id: string;
  isOpen: boolean;
  onClose: () => void;
  getApplicationElement: () => HTMLElement | null;
  children: ReactNode;
  title?: string;
  hideTitle?: boolean;
  closeLabel?: string;
  desktopWidth?: number;
  containerClassName?: string;
};

export const SponsoredDrawerShell = ({
  children,
  closeLabel,
  containerClassName,
  desktopWidth = 749,
  getApplicationElement,
  hideTitle = false,
  id,
  isOpen,
  onClose,
  title = '',
}: SponsoredDrawerShellProps) => {
  const isSmallScreen = !!useMediaQuery(BREAKPOINTS.SMALL_TABLET);
  const width = isSmallScreen ? '100%' : `calc(${onePixelRem} * ${desktopWidth})`;

  return (
    <BpkDrawer
      id={id}
      width={width}
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      hideTitle={hideTitle}
      closeLabel={closeLabel}
      getApplicationElement={getApplicationElement}
      containerClassName={containerClassName}
      className={STYLES.drawer}
    >
      {children}
    </BpkDrawer>
  );
};
